exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/core-js/modules/_object-gops.js
// module id = 184
// module chunks = 1